import React, {useEffect, useState} from 'react';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Toolbar from '@mui/material/Toolbar';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import {Checkbox, FormControlLabel, Stack} from '@mui/material';
import PlayerSelectPanel from '../player/PlayerSelectPanel';
import LoadingMask from '../components/LoadingMask';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#my-details-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const MyUserDetails = ({onClose}) => {

    const [user, setUser] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        loadData()
    }, []);

    const loadData = async () => {
        const response = await axios.get('/user-admin/loggedIn');
        setUser(response.data);
    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        setUser(prevState => ({
            ...prevState,
            [name]: value
        }))
    };

    const handleCheckboxChange = (e) => {
        const {name, checked} = e.target;
        setUser(prevState => ({
            ...prevState,
            [name]: checked
        }))
    };

    const handlePlayerSelect = (player) => {
        setUser(prevData => ({
            ...prevData,
            player: player
        }));
    };

    const handleClearPlayer = () => {
        setUser(prevData => ({
            ...prevData,
            player: null
        }));
    };

    const onSave = async () => {
        setSaving(true);
        try {
            await axios.post('/user-admin/loggedIn', user);
            onClose();
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog
            onClose={onClose}
            scroll={"paper"}
            open={true}
            fullWidth
            PaperComponent={PaperComponent}
            BackdropProps={{
                sx: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)", // Darker backdrop
                },
            }}
        >
            <Toolbar disableGutters variant='dense' sx={{m: 0, p: 0, display: 'flex'}}>
                <DialogTitle id="my-details-dialog-title" sx={{cursor: 'move', flexGrow: 1}}>My Details</DialogTitle>
                <IconButton
                    onClick={onClose}
                    sx={{borderRadius: 0}}
                >
                    <CloseIcon/>
                </IconButton>
            </Toolbar>
            <DialogContent sx={{
                m: 0,
                p: 0,
                paddingLeft: '20px',
                paddingRight: '20px',
            }}>
                <LoadingMask visible={saving}/>
                {user ?
                    <Stack spacing={1}>
                        <TextField
                            name="displayName"
                            label="Display name"
                            variant="standard"
                            value={user.displayName ?? ''}
                            onChange={handleChange}
                        />

                        <TextField
                            name="emailAddress"
                            label="Email Address"
                            type="email"
                            variant="standard"
                            value={user.emailAddress ?? ''}
                            onChange={handleChange}
                        />
                        <FormControlLabel control={<Checkbox name="emailNotifications"
                                                             checked={user.emailNotifications ?? false}
                                                             onChange={handleCheckboxChange}/>}
                                          label="Receive Email Notifications"/>

                        <PlayerSelectPanel defaultPlayer={user.player} onSelect={handlePlayerSelect}
                                           onClear={handleClearPlayer}/>
                    </Stack>
                    : <LoadingMask visible/>
                }
            </DialogContent>
            <DialogActions>
                <Button fullWidth variant="contained" onClick={onSave} disabled={saving || !user}>Save</Button>
                <Button fullWidth onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default MyUserDetails;
